// hooks/useTag.js
import { useSelector } from "react-redux";
import { selectDistrictData } from "store/slices";
import { useGetTagsQuery } from "store/api";
import useQueryLoader from "./useQueryLoader";

const NO_TAGS = [];

/**
 * All tags of the open district (every page), cached by RTK Query.
 * `hasMore` stays true until the list has loaded (false after an error: no tags).
 */
const useTag = () => {
  const { id } = useSelector(selectDistrictData);
  const { data, isFetching, isError, error } = useGetTagsQuery(id, { skip: !id });
  useQueryLoader(isFetching);

  return {
    loader: isFetching,
    tagData: data ?? NO_TAGS,
    error,
    hasMore: data === undefined && !isError,
  };
};

export default useTag;
